/*
 * @Author: shannyHuang
 * @Date: 2022-08-16 15:10:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-17 00:26:05
 * @FilePath: /wemeet-web-activity/src/components/LoadingTips/index.tsx
 */
import React from 'react';
import { StatusTip } from '@tencent/tea-component';
interface LoadingProps {
  show: Boolean;
  txt?: string;
  className?: string;
}
const LoadingTips = (props: LoadingProps) => {
  const { show, txt = '加载中....', className } = props;
  if (!show) return <></>;

  return (
    <div
      className={className}
      style={{
        margin: '30px 0',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      <StatusTip status="loading" loadingText={txt} />
    </div>
  );
};

export default LoadingTips;
